// import React from "react";
// import PrivacyPolicyBanner from "../Components/PrivacyPolicyBanner";
// import PrivacyInfo from "../Components/PrivacyInfo";

// const PrivacyPolicy = () => {
//   return (
//     <>
//       <PrivacyPolicyBanner />
//       <PrivacyInfo />
//     </>
//   );
// };

// export default PrivacyPolicy;
import React from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import SEO from "../../../global/components/SEO/SEO";
import PrivacyPolicyBanner from "../Components/PrivacyPolicyBanner";
import PrivacyInfo from "../Components/PrivacyInfo";

const PrivacyPolicy = () => {
  const seoData = getSEOData("/privacypolicy");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <PrivacyPolicyBanner />
      <PrivacyInfo />
    </>
  );
};

export default PrivacyPolicy;